export default function Page404(): JSX.Element {
    return (
        <div>No encontrado</div>
    );
}
